export default __webpack_public_path__ + "static/media/68_mobile.54660a69.jpg";